/**
 * The Spanish catalogue. It falls back to English KEY BY KEY, so an entry missing here does not leave a
 * hole: it leaves the English one, which is the worst acceptable case and not a blank screen.
 */
import boot from './boot.ts';
import door from './door.ts';
import entry from './entry.ts';
import fields from './fields.ts';
import hud from './hud.ts';
import keys from './keys.ts';
import lobby from './lobby.ts';
import loadout from './loadout.ts';
import markers from './markers.ts';
import match from './match.ts';
import readout from './readout.ts';
import sanction from './sanction.ts';
import touch from './touch.ts';
import zone from './zone.ts';

export default { boot, door, entry, fields, hud, keys, lobby, loadout, markers, match, readout, sanction, touch, zone };
